import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '影视资源',
    links: [
      { label: '热门电影', href: '/category/movie' },
      { label: '最新剧集', href: '/category/tv' },
      { label: '综艺节目', href: '/category/variety' },
      { label: '动漫番剧', href: '/category/anime' },
      { label: '纪录片', href: '/category/documentary' },
    ],
  },
  service: {
    title: '服务支持',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '常见问题', href: '/#faq' },
      { label: '播放帮助', href: '/#faq' },
      { label: '意见反馈', href: '/about' },
    ],
  },
  legal: {
    title: '法律信息',
    links: [
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
      { label: '版权声明', href: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-900">
                片多多影视
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              片多多影视提供海量高清免费影视资源，不卡顿在线观看。5万+影视内容覆盖电影、电视剧、综艺、动漫、纪录片，超清画质畅享流畅观影体验，完全免费无需注册。
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 片多多影视 版权所有 | 本站所有资源均来自网络，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200" aria-label="微博">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line text-lg"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200" aria-label="微信">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line text-lg"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200" aria-label="QQ">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-qq-line text-lg"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}